import Vue from 'vue'
const $http = Vue.prototype.$http
// 查询产品列表
function getList(params) {
  return $http({
    url: $http.adornUrl('/api/app/getProductInfo'),
    method: 'get',
    params: $http.adornParams(params)
  })
}
// 查询产品系列
function getTypes() {
  return $http({
    url: $http.adornUrl('/api/app/getProductSeries'),
    method: 'get',
    params: $http.adornParams()
  })
}
// 新增产品
function addProduction(data) {
  return $http({
    url: $http.adornUrl('/xxx/xxx'),
    method: 'post',
    data: $http.adornData(data)
  })
}
// 编辑产品
function editProduction(data) {
  return $http({
    url: $http.adornUrl('/xxx/xxx'),
    method: 'post',
    data: $http.adornData(data)
  })
}
// 删除产品
function delProduction(data) {
  return $http({
    url: $http.adornUrl('/xxx/xxx'),
    method: 'post',
    data: $http.adornData(data)
  })
}
// 获取公钥
function keys() {
  return $http({
    url: $http.adornUrl('/api/app/getKeys'),
    method: 'get',
    params: $http.adornParams()
  })
}
const httpMethods = { getList, getTypes, addProduction, editProduction, delProduction, keys }
export default httpMethods
